export default {"src":"/_next/static/media/call-fill.ffece6ea.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};